// Sem a configuração do Supabase, o app não abre (AC-234): não existe mais modo demonstração.
// Recebe os textos prontos — aparece antes de o app montar os provedores.
import { BeeLogo } from './Icon';

export function SetupMissing({ title, body }: { title: string; body: string }) {
  return (
    <main className="splash setup-missing" role="alert" data-testid="setup-missing">
      <BeeLogo size={48} />
      <h1>{title}</h1>
      <p>{body}</p>
    </main>
  );
}
